export * from "./header-tabs-component.module";
export * from "./header-tabs.component";
export * from "./models";
